module.exports = __webpack_public_path__ + "148005cce1dbc38a7228c8ffcdae2349.svg";